import TokenService from '@/services/token.service'
import ApiService from '@/services/api.service'

export default {
    namespaced: true,
	state: {
		accessToken: TokenService.getAccessToken(),
		refreshToken: TokenService.getRefreshToken(),
		user: TokenService.getClaim('user', {}),
	},
	getters: {
		isLoggedIn: state => !!state.accessToken,
		isAdmin: state => state.user.is_admin,
	},
	mutations: {
		setAccessToken(state, accessToken) {
			TokenService.setAccessToken(accessToken)
			state.accessToken = accessToken
			state.user = TokenService.getClaim('user', {})
		},
		removeAccessToken(state) {
			TokenService.removeAccessToken()
			state.accessToken = null
			state.user = {}
		},
		setRefreshToken(state, refreshToken) {
			TokenService.setRefreshToken(refreshToken)
			state.refreshToken = refreshToken
		},
		removeRefreshToken(state) {
			TokenService.removeRefreshToken()
			state.refreshToken = null
		},
		setUser(state, user) {
			state.user = user
		},
	},
	actions: {
        login({ commit }, credentials) {
			return ApiService.login(credentials)
				.then(data => {
					commit('setAccessToken', data.accessToken)
					commit('setRefreshToken', data.refreshToken)
                    return Promise.resolve(data)
				}).catch(() => {
					commit('removeAccessToken')
					commit('removeRefreshToken')
					return Promise.reject()
				})
		},
		async logout({ commit }) {
			commit('removeAccessToken')
			commit('removeRefreshToken')
		},
	},
}
